import { cn } from "@trendmap/ui/lib/utils";
import { type VariantProps, cva } from "class-variance-authority";
import React from "react";

export const typographyVariants = cva("block", {
  variants: {
    variant: {
      h1: "scroll-m-20 text-4xl font-extrabold tracking-tight lg: text-5xl",
      h2: "scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight first:mt-0",
      h3: "scroll-m-20 text-2xl font-semibold tracking-tight",
      h4: "scroll-m-20 text-xl font-semibold tracking-tight",
      p: "leading-7 not-first:mt-6",
      span: "block",
    },
    size: {
      large: "text-lg font-semibold",
      small: "text-sm font-medium leading-none",
    },
    affects: {
      default: "",
      lead: "text-xl text-muted-foreground",
      muted: "text-sm text-muted-foreground",
      removePMargin: "not-first:mt-0",
    },
  },
  defaultVariants: {
    variant: "span",
    affects: "default",
  },
});

export interface TypographyProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof typographyVariants> {}

const Typography = React.forwardRef<HTMLHeadingElement, TypographyProps>(
  ({ className, variant, affects, ...props }, ref) => {
    const Comp = variant || "span";
    return (
      <Comp
        className={cn(typographyVariants({ variant, affects, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Typography.displayName = "Typography";

export default Typography;
